export default "__VITE_ASSET__Db9qC0LL__"